import * as React from 'react';
import { UIText2 } from '@cian/ui-kit/typography';
import { INFRASTRUCTURE_MAP_ICON_MAP } from '../../../../constants/infrastructure';
import * as styles from './styles.css';

export interface IMapBalloonWithRouteProps {
  description: string;
  routeButtonId: string;
  title: string;
  type: string;
}

export function MapBalloonWithRoute({ description, routeButtonId, title, type }: IMapBalloonWithRouteProps) {
  const Icon = INFRASTRUCTURE_MAP_ICON_MAP.get(type);

  if (!Icon) {
    return null;
  }

  return (
    <div className={styles['balloon']}>
      <div className={styles['icon']}>
        <Icon color={'white_100'} />
      </div>
      <div>
        <UIText2>{title}</UIText2>
        <UIText2 color={'gray60_100'}>{description} мин. пешком</UIText2>
        <div className={styles['route']}>
          <button id={routeButtonId} className={styles['route-button']} type="button">
            Построить маршрут
          </button>
        </div>
      </div>
    </div>
  );
}
